// @file
// Referenced content carousel in Content grid pragraph type with Swiper.js
// @ToDo Would be nice to hide the pagination when there are not enough items to swipe.
// It could be done by counting the slide items, and make if statements
// based on breakpoints (or container width).

(function() {
  "use strict";

  function createElement(newel, name) {
    var newEl = document.createElement(newel);
    newEl.className = name;
    return newEl;
  }

  var refcontCarouselContainers = document.querySelectorAll('.referenced-content-carousel-container');

  Array.from(refcontCarouselContainers).forEach( function(item) {
    item.appendChild(createElement('div', 'rc-swiper-footer'));
    var rcFooter = item.querySelector('.rc-swiper-footer');

    rcFooter.appendChild(createElement('div', 'swiper-pagination'));
    var paginationContainer = item.querySelector('.swiper-pagination');

    rcFooter.appendChild(createElement('button', 'button--rcc-next'));
    rcFooter.insertBefore(createElement('button', 'button--rcc-prev'), paginationContainer);

    new Swiper (item, {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 18,
      roundLengths: true,
      pagination: {
        el: paginationContainer,
        clickable: true,
      },
      navigation: {
        nextEl: '.button--rcc-next',
        prevEl: '.button--rcc-prev',
      },
      breakpoints: {
        1229: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 18,
        },
        831: {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 8,
        },
      }
    })
  });
})();
